import _Typography from "@mui/material/Typography";
import { ThemeProvider } from '@mui/material/styles';
import React from 'react';
import { styled } from 'styled-components';
function WayPointPopup({
  theme,
  wayPoint: {
    address,
    addressDetail
  }
}) {
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(StyledTitle, null, addressDetail ? addressDetail.primaryText : address), addressDetail && addressDetail.secondaryText && /*#__PURE__*/React.createElement(_Typography, {
    color: "textSecondary",
    variant: "caption"
  }, addressDetail.secondaryText)));
}
const Wrapper = styled.div``;
const StyledTitle = styled(_Typography)`
  && {
    font-size: 1em;
  }
`;
export default WayPointPopup;